import { render } from "./HoverCounter.vue?vue&type=template&id=c5970cd8&scoped=true"
import script from "./HoverCounter.vue?vue&type=script&lang=js"
export * from "./HoverCounter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c5970cd8"

export default script